import {z} from 'zod';

export const UserAutoListItemSchema = z.object({
	id: z.number().int().positive(),
	email: z.string().email(),
	name: z.string(),
});

export type IUserAutoListItem = z.infer<typeof UserAutoListItemSchema>;
